import React from 'react';
import {
  BRAND_WIDGET_LAYOUT_TYPE_V2,
  BrandWidgetDetailV2,
  BrandWidgetRequestPayloadV2,
  WIDGET_TYPE_V2,
} from '../../../../../types/widget';
import { getInitialPeriod } from '../../common/utils/getInitialPeriod';
import BrandWidgetForm from './BrandWidgetForm';

export interface BrandWidgetFormWrapperProps {
  isEdit: boolean;
  initialValue?: BrandWidgetDetailV2;
  onChangeType: (type: WIDGET_TYPE_V2) => void;
  onFinish: (value: BrandWidgetRequestPayloadV2) => void;
}

const BrandWidgetFormWrapper = (props: BrandWidgetFormWrapperProps): JSX.Element => {
  const { initialValue, isEdit, onFinish, onChangeType } = props;

  const { exposurePeriod, ...restInitialValue } = initialValue || {};

  const formInitialValue = {
    type: WIDGET_TYPE_V2.BRAND,
    layoutType: BRAND_WIDGET_LAYOUT_TYPE_V2.GRID_1X4,
    exposurePeriod: getInitialPeriod(exposurePeriod),
    ...restInitialValue,
  };

  return (
    <BrandWidgetForm isEdit={isEdit} initialValue={formInitialValue} onFinish={onFinish} onChangeType={onChangeType} />
  );
};

export default BrandWidgetFormWrapper;
